import { Ref, ref, onMounted } from 'vue';
import { PolicyDocInfo } from '@/models/PolicyDocumentsModels';
import { useCommercialApi } from '@/composables/UseCommercialApi';
import { CommercialApiConfig } from '@/services/CommercialApiConfig';
import { Message } from '@/contracts/OperationResult';

export function usePolicyDocumentsLogic(
	policyNumber: Ref<string>,
	filter: Ref<string | null> = ref(null)
) {
	const { getPolicyDocs } = useCommercialApi(CommercialApiConfig);
	
	// State variables
	const policyDocs = ref<PolicyDocInfo[]>([]);
	const errorMessage = ref<Message[]>([]);
	const isLoading = ref<boolean>(false);

	const loadPolicyDocuments = async () => {
		if (!policyNumber.value) {
			errorMessage.value.push({
				type: 'error',
				content: 'No policy number provided.'
			});
			return;
		}

		isLoading.value = true;

		const result = await getPolicyDocs(policyNumber.value, filter.value);
		policyDocs.value = result ?? [];

		isLoading.value = false;
	};

	onMounted(async () => {
		await loadPolicyDocuments();
	});

	return {
		policyDocs,
		errorMessage,
		isLoading
	};
}
